/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDeleteUserReplyTemplateRequest,
  TDeleteUserReplyTemplateModel,
  IMappers,
  TDeleteUserReplyTemplateResponse,
  TDeleteUserReplyTemplateResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createDeleteUserReplyTemplateModel(
  parameters: TDeleteUserReplyTemplateRequest,
): TDeleteUserReplyTemplateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/delete-user-reply-template/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDeleteUserReplyTemplateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDeleteUserReplyTemplateRequest;
}

export async function fetchDeleteUserReplyTemplate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteUserReplyTemplateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDeleteUserReplyTemplateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDeleteUserReplyTemplateModel(parameters),
    config,
  )) as FetchResponse<TDeleteUserReplyTemplateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TDeleteUserReplyTemplateResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDeleteUserReplyTemplateResponse>;
}
